module.exports = __webpack_public_path__ + "img/drop_down.044a0b27.svg";